import { Type } from '@sinclair/typebox';
// GET /settings/branding — returned to any authenticated caller (admin, hub
// root page, every track frontend) so the shared header can resolve the
// company logo. The image bytes themselves live behind GET /settings/logo;
// the URL here already includes the etag as a cache-busting query string.
export const SettingsBrandingResponseSchema = Type.Object({
    logoUrl: Type.Union([Type.String(), Type.Null()]),
    logoEtag: Type.Union([Type.String(), Type.Null()]),
    logoMime: Type.Union([Type.String(), Type.Null()]),
    // HUB-125 D7: the dark-mode variant (bytes at GET /settings/logo/dark), or
    // null when none is uploaded — the header then shows `logoUrl` in both modes.
    logoDarkUrl: Type.Union([Type.String(), Type.Null()]),
    // HUB-125 D4: the admin-set `portal.landing_url` (null when unset). With one
    // set the portal root is replaced by it, so the shared header points its
    // Portal item there instead of at `appBaseUrl`.
    landingUrl: Type.Union([Type.String(), Type.Null()]),
    // The hub's APP_BASE_URL — the origin of the admin SPA / portal. The shared
    // header builds its portal + Admin links from this; null when unset.
    appBaseUrl: Type.Union([Type.String(), Type.Null()]),
});
//# sourceMappingURL=settings.js.map